import PropTypes      from 'prop-types';
import React          from 'react';
import ReactDOM       from 'react-dom';
import styles         from 'components/MultiSelectIcons/MultiSelectIcons.scss';

export default class MultiSelectIcons extends React.Component {
  constructor() {
    super();
  }

  componentDidMount() {
    this.node = ReactDOM.findDOMNode(this);
  }

  select(value) {
    let newValue = value;
    if (this.props.value.indexOf(value) > -1) {
      newValue = this.props.value.filter(v => v !== value);
    } else {
      newValue = this.props.value.concat([value]);
    }
    this.props.onChange(newValue);
  }

  render() {
    return (
      <div className={styles.icons}>
        {React.Children.map(this.props.children, c => React.cloneElement(c,
          {
            ...c.props,
            checked: this.props.value.indexOf(c.props.value) > -1,
            onClick: this.select.bind(this, c.props.value)
          }
        ))}
      </div>
    );
  }
}

MultiSelectIcons.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.arrayOf(PropTypes.string).isRequired,
  children: PropTypes.node.isRequired,
}
